"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fedops_logger_1 = require("@wix/fedops-logger");
var bookings_consts_1 = require("@wix/bookings-uou-domain/dist/src/constants/bookings.consts");
var fedops_const_1 = require("./fedops.const");
var FedopsAdapter = /** @class */ (function () {
    function FedopsAdapter(wixSdkAdapter, fedopsAppName, widgetId) {
        this.wixSdkAdapter = wixSdkAdapter;
        if (this.wixSdkAdapter.isRunningInIframe()) {
            this.fedopsAppName = fedopsAppName;
            this.fedopsLogger = fedops_logger_1.create(this.fedopsAppName);
        }
        else {
            var platformAPIs = wixSdkAdapter.getPlatformAPIs();
            this.fedopsLogger = platformAPIs.fedOpsLoggerFactory.getLoggerForWidget({
                appId: bookings_consts_1.BOOKINGS_APP_DEF_ID,
                widgetId: widgetId,
            });
            var isServerSide = this.wixSdkAdapter.isSSR();
            this.fedopsAppName = "" + fedopsAppName + fedops_const_1.FEDOPS_APP_NAME_OOI_SUFFIX + (isServerSide ? fedops_const_1.FEDOPS_APP_NAME_SSR_SUFFIX : '');
            this.oldFedopsLogger = fedops_logger_1.create(this.fedopsAppName, {
                isWidgetLogger: true,
                isServerSide: isServerSide,
                appId: bookings_consts_1.BOOKINGS_APP_DEF_ID,
                widgetId: widgetId,
            });
            this.logAppLoadedStarted();
        }
    }
    FedopsAdapter.prototype.logAppLoadedStarted = function () {
        this.fedopsLogger.appLoadStarted();
        this.oldFedopsLogger && this.oldFedopsLogger.appLoadStarted();
    };
    FedopsAdapter.prototype.logAppLoaded = function () {
        this.fedopsLogger.appLoaded();
        this.oldFedopsLogger && this.oldFedopsLogger.appLoaded();
    };
    return FedopsAdapter;
}());
exports.FedopsAdapter = FedopsAdapter;
//# sourceMappingURL=fedops-adapter.js.map